import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { BossardCredentialsInputDTORuntype, BossardResponseBodyDTORuntype } from './bossardBackendTypes';

export const bossardEndpoints = {
    'GET /3rdparty/bossard/credentials': endpoint({
        description: 'Returns credentials for Bossard integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: BossardResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/bossard/credentials'],
    }),
    'POST /3rdparty/bossard/credentials': endpoint({
        description: 'Uploads credentials for Bossard integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: BossardCredentialsInputDTORuntype,
        responseBody: BossardResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/bossard/credentials'],
    }),
    'PATCH /3rdparty/bossard/credentials': endpoint({
        description: 'Updates credentials for Bossard integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: BossardCredentialsInputDTORuntype,
        responseBody: BossardResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/bossard/credentials'],
    }),
    'DELETE /3rdparty/bossard/credentials': endpoint({
        description: 'Deletes credentials for Bossard integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/bossard/credentials'],
    }),
};
